/* ======= Custom Validation Message ====== */
function showNativeError(message, classAttr) {
  const errorWrapper = document.querySelector(`.${classAttr}`);
  if (!errorWrapper) return;
  errorWrapper.textContent = message;
  errorWrapper.removeAttribute('hidden');
}

/* ======= Clear Validation Error Message ====== */
function clearNativeError(classAttr) {
  if (classAttr) {
    const errorWrapper = document.querySelector(`.${classAttr}`);
    if (!errorWrapper) return;
    errorWrapper.textContent = '';
    errorWrapper.setAttribute('hidden', '');
  } else {
    document.querySelectorAll('[class$="-error"]').forEach(el => {
      el.textContent = '';
      el.setAttribute('hidden', '');
    });
  }
}

/* ======= Global ATC Validation Runner ======= */
function validateRequiredFields() {
  let isValid = true;
  document.querySelectorAll('[data-required="true"]').forEach(field => {
    const errorClass = field.dataset.errorClass;
    const errorMsg   = field.dataset.errorMsg || 'This field is required.';

    if (!field.value || !field.value.trim()) {
      isValid = false;
      if (errorClass) showNativeError(errorMsg, errorClass);
    } else {
      if (errorClass) clearNativeError(errorClass);
    }
  });
  return isValid;
}

/* ===== GLOBAL DROPDOWN HANDLER ===== */
document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".custom-dropdown__trigger");
  if (trigger) {
    const currentDropdown = trigger.parentElement;
    const isAlreadyOpen = currentDropdown.classList.contains("is-open");
    document.querySelectorAll(".custom-dropdown.is-open").forEach((dd) => dd.classList.remove("is-open"));
    if (!isAlreadyOpen) currentDropdown.classList.add("is-open");
    return;
  }
  const option = e.target.closest(".custom-dropdown__option");
  if (option) {
    const dropdown   = option.closest(".custom-dropdown");
    const selectId   = dropdown.dataset.selectId;
    const select     = document.getElementById(selectId);
    const value      = option.dataset.value;
    const label      = dropdown.querySelector(".custom-dropdown__label");
    const optionText = option.dataset.value;

    if (label) {
      label.textContent = optionText;
    }

    dropdown.querySelectorAll(".custom-dropdown__option").forEach((btn) => btn.classList.remove("is-active"));
    option.classList.add("is-active");
    dropdown.classList.remove("is-open");

    if (select) select.value = value;
    if (select) select.dispatchEvent(new Event("change", { bubbles: true }));

    /* ======= IN STOCK RINGS: Bespoke product functionality for Leadtime ======= */
    const productTags = window.currentProductJson ? window.currentProductJson.tags : [];
    const isBespokeProduct = productTags?.includes('show-bespoke-flash-product');
    const hasInstockLogic = productTags?.includes('fetch-oms-leadtime-in-stock');

    if (isBespokeProduct && hasInstockLogic){
      const leadtimeEl = document.querySelector('[id^="LeadTimeMsg-"]');
      const leadtime = leadtimeEl?.getAttribute('data-lead-time');
      const bespokeTag = productTags.find(tag => tag.includes('bespoke-size-'));

      let bespokeSize = '';
      if (bespokeTag) {
        bespokeSize = bespokeTag.replace('bespoke-size-', '').trim();
      }

      const selectedSize = optionText.trim();
      const ledTimeContainer = document.getElementById('rc-leadtime-display');
      const leadtimeSwatch = document.getElementById('rc-leadtime-swatch');

      if (!ledTimeContainer) return;
      if (!leadtimeSwatch) return;

      if (selectedSize && bespokeTag && Number(selectedSize) === Number(bespokeSize)){
        ledTimeContainer.textContent = 'Only 1 left in stock!';
        leadtimeSwatch.classList.remove('rc-swatch--orange');
        leadtimeSwatch.classList.add('rc-swatch--green');
        leadtimeSwatch.innerHTML = '<span class="rc-swatch__dot"></span>In Stock';
      } else {
        ledTimeContainer.textContent = leadtime;
        leadtimeSwatch.classList.add('rc-swatch--orange');
        leadtimeSwatch.classList.remove('rc-swatch--green');
        leadtimeSwatch.innerHTML = '<span class="rc-swatch__dot"></span>Made to Order';
      }
    }

    const url = option.dataset.url;
    if (url && url.trim() !== "") {
      window.location.href = url;
    }
    return;
  }
  document.querySelectorAll(".custom-dropdown.is-open").forEach((dd) => dd.classList.remove("is-open"));
});

$(document).on("click", ".custom-dropdown__option", function () {
  const url = $(this).data("url");
  if (url && url.trim() !== "") {
    window.location.href = url;
  }
});

function setActive(clickedBtn) {
  const buttons = document.querySelectorAll(".toggle-btn");
  buttons.forEach((btn) => btn.classList.remove("is-active"));
  clickedBtn.classList.add("is-active");
}

$(document).on("click", ".rc-js-video", function (e) {
  e.preventDefault();
  e.stopPropagation();
  
  const $deferredMedia = $(this).closest('deferred-media');
  const $container = $deferredMedia.closest('.product-media-container');
  const $playBtn = $container.find('.rc-video-play-button');
  const $poster = $deferredMedia.find('.media-poster');

  if (this.paused) {
    this.play();
    $playBtn.addClass('is-hide');
  } else {
    this.pause();
    $playBtn.removeClass('is-hide');
    $poster.removeClass('is-hide');
  }
});

/* ======= Auto-pause video on scroll (mobile) ======= */
var scrollObserver = null;
function observeVideo(video) {
  if (!window.matchMedia('(max-width: 768px)').matches) return;
  if (video._scrollObserved) return;
  video._scrollObserved = true;

  // Lazy-init the observer on first use
  if (!scrollObserver) {
    scrollObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const vid = entry.target;
          if (!entry.isIntersecting && !vid.paused) {
            vid.pause();
            const $container = $(vid).closest('.product-media-container');
            const $parent    = $(vid).closest('deferred-media');
            $container.find('.rc-video-play-button').removeClass('is-hide');
            $parent.find('.media-poster').removeClass('is-hide');
          }
        });
      },
      { threshold: 0.25 }
    );
  }
  scrollObserver.observe(video);
}

$(document).on("click", ".rc-video-play-button", function (e) {
  e.stopPropagation();
  $(this).addClass('is-hide');

  let $parent = $(this).closest('deferred-media');
  if (!$parent.length) $parent = $(this).siblings('deferred-media');

  const $container = $parent.closest('.product-media-container');
  const deferredEl = $parent.get(0);

  // If video already exists in the DOM, just resume
  const existingVideo = $parent.find('.rc-js-video').get(0);
  if (existingVideo) {
    observeVideo(existingVideo);
    existingVideo.play().catch(() => {
      existingVideo.muted = true;
      existingVideo.play().catch(err => console.log('iOS resume failed:', err));
    });
    return;
  }

  /* ======= FIRST-TIME LOAD :: First Manually find the <source> from the <template> and build ======= */
  const template = deferredEl.querySelector('template');
  let videoSrc = null;
  let videoType = 'video/mp4';

  if (template) {
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(template.content.cloneNode(true));
    const sourceEl = tempDiv.querySelector('source');
    const videoEl  = tempDiv.querySelector('video');
    if (sourceEl) {
      videoSrc  = sourceEl.getAttribute('src');
      videoType = sourceEl.getAttribute('type') || videoType;
    } else if (videoEl) {
      videoSrc = videoEl.getAttribute('src');
    }
  }

  if (videoSrc) {
    // Build and inject the video synchronously so iOS gesture context is intact
    const video = document.createElement('video');
    video.className       = 'rc-js-video';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.muted           = true;   // required for iOS first-play
    video.loop            = true;
    video.controls        = false;
    video.style.cssText   = 'position:absolute;inset:0;width:100%!important;height:100%!important;z-index:1;object-fit:contain;display:block!important;';

    const source = document.createElement('source');
    source.src  = videoSrc;
    source.type = videoType;
    video.appendChild(source);

    // Remove the template so loadContent() won't double-inject later
    if (template) template.remove();
    deferredEl.appendChild(video);

    // Play synchronously within the gesture
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.then(() => {
        // Playback started — now safe to unmute
        video.muted = false;
        $parent.find('.media-poster').addClass('is-hide');
        observeVideo(video);
      }).catch(() => {
        // Still muted fallback (very restricted iOS)
        video.muted = true;
        video.play().catch(err => console.log('iOS fallback play failed:', err));
        observeVideo(video);
      });
    }

    // Attach ongoing pause/play UI listeners
    video.addEventListener('pause', function () {
      $container.find('.rc-video-play-button').removeClass('is-hide');
      $parent.find('.media-poster').removeClass('is-hide');
    });
    video.addEventListener('playing', function () {
      $container.find('.rc-video-play-button').addClass('is-hide');
      $parent.find('.media-poster').addClass('is-hide');
    });
  } else {
    // Fallback: no <source> found in template, use loadContent() as last resort
    if (deferredEl && typeof deferredEl.loadContent === 'function') {
      deferredEl.loadContent();
    } else if (template) {
      deferredEl.appendChild(template.content.cloneNode(true));
      template.remove();
    }

    const video = $parent.find('.rc-js-video').get(0);
    if (!video) return;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.muted = true;
    video.removeAttribute('poster');

    video.addEventListener('playing', function onFirstPlay() {
      video.removeEventListener('playing', onFirstPlay);
      video.muted = false;
      $parent.find('.media-poster').addClass('is-hide');
      observeVideo(video);

      video.addEventListener('pause', function () {
        $container.find('.rc-video-play-button').removeClass('is-hide');
        $parent.find('.media-poster').removeClass('is-hide');
      });
      video.addEventListener('playing', function () {
        $container.find('.rc-video-play-button').addClass('is-hide');
        $parent.find('.media-poster').addClass('is-hide');
      });
    });

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(err => console.log('iOS fallback play failed:', err));
    }
  }
});

$(document).on("click", ".product-media-container", function (e) {
  const $playBtn = $(this).find('.rc-video-play-button');
  if ($playBtn.hasClass('is-hide')) {
    const video = $(this).find('.rc-js-video').get(0);
    if (!video) return;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }
});

/* ====== Manage Lead time position for Bundle sets product ====== */
if (currentProductJson && currentProductJson?.type?.toLowerCase() === 'bundle sets') {
  // Inject CSS once, dynamically, only for this product type
  (function injectLeadTimeCss() {
    if (document.getElementById('rc-leadtime-bundle-css')) return; // avoid duplicate <style> on repeated section renders

    var style = document.createElement('style');
    style.id = 'rc-leadtime-bundle-css';
    style.textContent = '.rc-leadtime-row { margin-top: 0; margin-bottom: 10px; }';
    document.head.appendChild(style);
  })();

  function moveLeadTimeAboveAddToCart(root) {
    root = root || document;
    root.querySelectorAll('.rc-leadtime-row').forEach(function (leadTimeRow) {
      // Scope to the specific product-info block this lead time row belongs to
      var productInfo = leadTimeRow.closest('.product-info');
      if (!productInfo) return;

      var buttonsWrapper = productInfo.querySelector('.product-form-buttons');
      if (buttonsWrapper && buttonsWrapper.parentNode && leadTimeRow.nextElementSibling !== buttonsWrapper) {
        buttonsWrapper.parentNode.insertBefore(leadTimeRow, buttonsWrapper);
      }

      // Apply spacing directly at move-time — wins over any inherited/theme margin
      leadTimeRow.style.marginTop = '0';
      leadTimeRow.style.marginBottom = '10px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      moveLeadTimeAboveAddToCart();
    });
  } else {
    moveLeadTimeAboveAddToCart();
  }
}